import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

const mailServices = (action: any) => {
  const postSendMailData = {
    member_id: action.memberID,
    mail_address: action.mailAddress,
  };

  const putMailAddressData = {
    code: action.code,
  };

  return {
    postSendMail: () => apiClient.post(`${API_BASE_ADDRESS}/mypage/member/send-mail`, postSendMailData),
    putMailAddress: () => apiClient.put(`${API_BASE_ADDRESS}/member/mailaddress`, putMailAddressData),
  };
};

export default mailServices;
